export const HIGHLIGHTED_CLASS = 'bg-gray-200 shadow-inner'
